module.exports = __webpack_public_path__ + "media/images/kumu-step3-ef0f23c2396e20b1a03f570b2d62bd71.png";